import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const UriageTorihiki = props => {
  return <Dropdown.Static kubunKey='uriage_torihiki' {...props} />
}
